<nb-select fullWidth [(selected)]="value" [disabled]="isDisabled" [compareWith]="compareTenants">
  <nb-option *ngIf="showEmptyOption" [value]="{id: undefined}">Alle</nb-option>
  <nb-option *ngFor="let tenant of tenants" [value]="tenant">{{tenant.name}}</nb-option>
</nb-select>
